import { Select as $Select } from '@mantine/core';
import type { SelectProps as $SelectProps } from '@mantine/core';
import { useController } from 'react-hook-form';
import type { FieldValues, UseControllerProps } from 'react-hook-form';

import { parseError } from './lib/parseError.ts';

type SelectProps<T extends FieldValues> = UseControllerProps<T> & Omit<$SelectProps, 'value' | 'defaultValue'>;

export function Select<T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  onChange,
  label,
  ...props
}: SelectProps<T>) {
  const {
    field: { value, onChange: fieldOnChange, ref: _fieldRef, ...field },
    fieldState,
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <$Select
      error={parseError(label, fieldState.error)}
      radius="xs"
      value={value}
      onChange={(value, comboBoxItem) => {
        fieldOnChange(value);
        onChange?.(value, comboBoxItem);
      }}
      {...field}
      {...props}
      checkIconPosition="right"
      label={label}
    />
  );
}
